const toggleShowDisclaimer = () =>  {
    $('.notre-demarche').hover(function() {
        $('.disclaimer-wrapper').show();
    }, function() {
        $('.disclaimer-wrapper').hide();
    });
}

export { toggleShowDisclaimer };
